import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import SignTypesListPage from '../components/SignTypesListPage'
import {
  actionCreators,
  ISignTypesListState,
  selectError,
  selectFilterText,
  selectIsLoading,
  selectItems,
  selectNewSignType,
  selectTotalItems,
} from '../modules/signTypesList'

export default connect(
  createStructuredSelector<
    ApplicationState,
    ISignTypesListState & ICurrentUserState
  >({
    error: selectError(),
    filterText: selectFilterText(),
    isLoading: selectIsLoading(),
    items: selectItems(),
    newSignType: selectNewSignType(),
    totalItems: selectTotalItems(),
    user: selectCurrentUser(),
  }),
  actionCreators,
)(SignTypesListPage)
